<template>
  <div class="promo-card" :class="button && '--button'">
    <div class="promo-card__icon">
      <img :src="IconGift" alt="Gift" />
      <span class="promo-card__amount">
        <span>$</span>
        {{ promoAmount }}
      </span>
    </div>
    <div class="promo-card__description">
      {{ $t(title, { amount: promoAmount }) }}
    </div>
    <div v-if="button" class="promo-card__arrow-icon">
      <svgo-arrow-right class="icon" />
    </div>
  </div>
</template>

<script setup>
import IconGift from '@/assets/icons/gift.png';

defineProps({
  title: {
    type: String,
    default: 'bonus.card_text',
  },
  button: {
    type: Boolean,
    default: false,
  },
  promoAmount: {
    type: [Number, String],
    default: null,
  },
});
</script>

<style lang="scss">
@use '@/assets/styles/components/pages/project/promoCard.scss' as *;
</style>
